import { Icon } from '@mui/material';

import { GDMIconComponent } from './GDMIcon.type';

/* TODO: Implement component using GDM default design */
const GDMIcon: GDMIconComponent = props => <Icon {...props} />;

export default GDMIcon;
